export const DIALOGS = {
  TABLE_ROW_CREATE_DIALOG: 'TABLE_ROW_CREATE_DIALOG',
  TABLE_ROW_EDIT_DIALOG: 'TABLE_ROW_EDIT_DIALOG',
  TABLE_ROW_DELETE_DIALOG: 'TABLE_ROW_DELETE_DIALOG',
  SWITCH_ROLE_DIALOG: 'SWITCH_ROLE_DIALOG',
  PERMISSION_UPDATE_DIALOG: 'PERMISSION_UPDATE_DIALOG',
  DATA_LOSS_DIALOG: 'DATA_LOSS_DIALOG',
};
